@if (!loading()){
<div class="login-bg flex h-screen flex-col items-center justify-between overflow-x-hidden bg-gray-50">
  <div class="flex w-full flex-1 flex-col items-center justify-center px-4 py-6 text-center sm:px-6 sm:py-12 md:w-4/12">
    <div class="flex w-full max-w-md items-center justify-center">

      <div class="w-full min-w-0 space-y-6">
<!--        <h2 class="text-4xl font-bold  text-center text-primary">-->
<!--          Mi Back Office-->
<!--        </h2>-->

        <h1 class="logo-text">
<!--          <span class="text-light">Mi Back</span> Office-->
          Mi Back Office{{ (store?.pais || corporativoSeleccionado()?.pais)
            ? ' - ' + (store?.pais || corporativoSeleccionado()?.pais)
            : '' }}
        </h1>
        @if (store){
          <section class="!mt-3 mx-0 block w-full min-w-0 -translate-x-2.5 self-stretch box-border rounded-2xl border border-slate-200/80 bg-white/80 px-3 py-2.5 text-left shadow-sm backdrop-blur-sm sm:px-4 sm:py-3">
            <div class="flex min-w-0 items-center gap-2.5 sm:gap-3">
              <span class="grid h-8 w-8 shrink-0 place-items-center rounded-xl bg-primary/10 text-primary sm:h-9 sm:w-9">
                <i class="pi pi-building" aria-hidden="true"></i>
              </span>

              <div class="min-w-0 flex-1">
                @if (store.tipoPV === tipoTienda.Corporativo) {
                  <span
                    class="inline-flex rounded-full bg-blue-100 px-2 py-0.5 text-[9px] font-bold text-blue-700 sm:text-[10px]">
                    Corporativo
                  </span>
                }

                <div class="mt-1 min-w-0">
                  <p
                    class="m-0 break-words text-xs font-bold leading-5 text-slate-800 sm:text-sm"
                    [title]="'(' + store.pais + ') ' + (store.razonSocial || '')">
                    ({{ store.pais }}) {{ store.razonSocial || 'Razón social no disponible' }}
                  </p>

                  <div class="flex min-w-0 items-center gap-1">
                    <p
                      class="m-0 min-w-0 break-words text-[11px] font-semibold leading-4 text-slate-600 sm:text-xs sm:leading-5"
                      [title]="store.puntoVenta + (store.descripcionPuntoVenta ? ' - ' + store.descripcionPuntoVenta : '')">
                      {{ store.puntoVenta }}{{ store.descripcionPuntoVenta ? ' - ' + store.descripcionPuntoVenta : '' }}
                    </p>
                  @if (revisaStore()) {
                    <button
                      type="button"
                      class="ml-1 inline-flex cursor-pointer border-0 bg-transparent p-0"
                      pTooltip="Configuración temporal"
                      tooltipPosition="right"
                      aria-label="Ver configuración temporal"
                      (click)="abrirConfiguracion()">
                      <i class="pi pi-info-circle text-xs font-bold text-red-500"></i>
                    </button>
                  }
                  </div>
                </div>
              </div>
            </div>
          </section>
        }

            <!-- Email -->
        <form class="mx-0 block w-full min-w-0 box-border" [formGroup]="form" (ngSubmit)="loginEmail()">
          @if (!equipoRegistrado()) {
            <div class="mb-5 text-left">

              <label
                for="corporativo"
                class="mb-2 block text-sm font-semibold text-slate-700"
              >
                Sociedad
                <span class="text-red-500">*</span>
              </label>

              <p-select
                inputId="corporativo"
                [options]="corporativos"
                [ngModel]="corporativoSeleccionado()"
                (ngModelChange)="corporativoSeleccionado.set($event)"
                [ngModelOptions]="{ standalone: true }"
                optionLabel="label"
                placeholder="Selecciona una Sociedad"
                appendTo="body"
                styleClass="w-full"
              >
                <ng-template pTemplate="item" let-item>
                  <span>
                    <b>{{ item.pais }}-</b>{{ item.label }}
                  </span>
                </ng-template>

                <ng-template pTemplate="selectedItem" let-item>
                  @if (item) {
                    <span>
                      <b>{{ item.pais }}-</b>{{ item.label }}
                    </span>
                  }
                </ng-template>
              </p-select>

              <p class="mt-2 text-xs text-slate-500">
                Selecciona una sociedad únicamente para realizar
                la configuración inicial del equipo.
              </p>

            </div>
          }
          <div class="mb-6">
            <div class="relative w-full">
              <i
                class="pi pi-user absolute left-3 top-1/2 z-10
               -translate-y-1/2 text-slate-400"
              ></i>

              <input
                pInputText
                type="text"
                placeholder="Usuario"
                class="w-full !pl-10"
                formControlName="email"
              />

            </div>
          </div>


          <!-- Password -->
          <div class="mb-6">
            <div class="relative w-full">

              <i
                class="pi pi-key absolute left-3 top-1/2 z-10
               -translate-y-1/2 text-slate-400">
              </i>

              <p-password
                id="password"
                formControlName="password"
                [feedback]="false"
                [toggleMask]="true"
                placeholder="*****"
                styleClass="w-full"
                inputStyleClass="w-full !pl-10 !pr-10 "
              >
                <ng-template #showicon>
                  <i class="pi pi-eye-slash"></i>
                </ng-template>

                <ng-template #hideicon>
                  <i class="pi pi-eye"></i>
                </ng-template>

              </p-password>

            </div>
          </div>

          @if (errorMessage) {
            <p-message severity="error" variant="simple" class="mb-4">
              {{ errorMessage }}
            </p-message>
          }

          @if (googleMessage) {
            <p-message severity="info" variant="simple" class="mb-4">
              {{ googleMessage }}
            </p-message>
          }

          <button
            pButton
            type="submit"
            class="w-full border-none bg-primary"
            [disabled]="form.invalid || (!equipoRegistrado() && !corporativoSeleccionado())"
          >
            Continuar
          </button>

          @if (esAccesoCorporativo()) {
            <img
              src="images/logos/google-logo.png"
              alt="Acceso corporativo con Google"
              role="button"
              tabindex="0"
              pTooltip="Acceder con correo"
              tooltipPosition="top"
              class="mx-auto mt-3 h-12 w-12 cursor-pointer object-contain transition-transform duration-200 ease-out hover:scale-125 focus-visible:scale-125 focus-visible:rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
              (click)="loginGoogle()"
              (keydown.enter)="loginGoogle()"
              (keydown.space)="$event.preventDefault(); loginGoogle()"
            />
          }
        </form>


      </div>
    </div>

  </div>

  <div class="flex flex-col items-center px-4 pb-6 text-center">
    <h6 class="m-0 max-w-[320px] text-xs font-medium leading-5 text-primary
           md:max-w-none md:text-sm" style="line-height: 17px">Copyright Ⓒ Mi Back Office {{ year  }}
          <span class="hidden md:inline"> | </span>
          <br class="md:hidden" />
          Todos los derechos reservados..
    </h6>
    <span class="mt-3 max-w-[350px] break-all text-[10px]
           font-medium leading-4 text-primary md:text-xs">Versión {{ versionService.version }} {{ deviceId ? ' - ' + deviceId: '' }}
<!--      <button-->
<!--        type="button"-->
<!--        class="icon-info-btn ml-2"-->
<!--        pTooltip="RegistroEquipo"-->
<!--        tooltipPosition="right"-->
<!--        (click)="navegarRegistro()">-->
<!--          <i class="pi pi-desktop text-blue-950 font-bold  " style="font-size: smaller"></i>-->
<!--        </button>-->
    </span>

  </div>
</div>
}
@else {
  <div class="flex items-center justify-center flex-col h-screen bg-gray-50 login-bg">
    <div class="flex flex-col items-center justify-center w-full md:w-4/12 h-full text-center py-12 px-6">

    </div>
  </div>
}
<!-- MODAL REGISTRO DE EQUIPO -->
<p-dialog
  header="Equipo no registrado"
  [(visible)]="showRegisterModal"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [style]="{ width: '420px' }">

  <div class="text-center p-4">
    <i class="pi pi-desktop mb-3 text-primary" style="font-size: 3rem;"></i>

    <h3 class="mb-2">Registro requerido</h3>

    <p class="text-secondary mb-4">
      Este equipo no está registrado en el sistema.
      Es necesario completar el registro para continuar.
    </p>

    <button
      pButton
      label="Registrar equipo"
      icon="pi pi-arrow-right"
      class="p-button-success w-100"
      (click)="goToRegister()">
    </button>
  </div>

</p-dialog>
<!-- Modal informativo de cierre por inactividad oculto temporalmente.
<p-dialog
  header="Inactividad"
  [(visible)]="showidleModal"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [style]="{ width: '420px' }">

  <div class="text-center p-4">
    <i class="pi pi-clock mb-3 text-primary" style="font-size: 3rem;"></i>

    <p class="text-secondary mb-4">
      Después de un periodo de inactividad, hemos cerrado la sesión por tu seguridad.
    </p>
    <p class="text-secondary mb-4 font-bold"> {{ minutos }} minutos </p>
    <button
      pButton
      label="Aceptar"
      class="p-button-success w-100"
      (click)="idleOK()">
    </button>
  </div>

</p-dialog>
-->
